import { css } from '@emotion/core';
import { tokens, shadow } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  shadows = tokens.shadows;
export var doughnutGraph = /*#__PURE__*/css("position:relative;display:flex;flex-direction:column;align-items:center;border-radius:10px;border:1px solid ", colors.neutral.trim.default, ";padding:24px 16px;flex-grow:1;");
export var graph = {
  name: "1i0si6u",
  styles: "position:relative;width:156px;height:156px;"
};
export var spacer = /*#__PURE__*/css("width:100%;height:0;border-top:1px solid ", colors.neutral.trim.default, ";margin:24px 0;");
export var legend = /*#__PURE__*/css("display:flex;flex-direction:column;gap:16px;width:100%;", designTokenFonts.body, " color:", colors.neutral.heavy.default, ";");
export var legendItem = {
  name: "70qvj9",
  styles: "display:flex;align-items:center;"
};
export var legendLabel = {
  name: "x1sij0",
  styles: "display:flex;align-items:baseline;"
};
export var line = /*#__PURE__*/css("flex-grow:1;height:0;border-top:1px dashed ", colors.neutral.trim.default, ";margin:0 8px;");
export var legendValue = /*#__PURE__*/css(designTokenFonts.bodyBold);
export var roundel = _ref => {
  var colour = _ref.colour;
  return /*#__PURE__*/css("position:relative;top:3px;height:16px;width:16px;border-radius:8px;border:4px solid ", colour, ";");
};
export var legendRoundelSpacer = {
  name: "12z0wuy",
  styles: "margin-right:8px;"
};
export var title = /*#__PURE__*/css("margin-bottom:10px;", designTokenFonts.subheading, " color:", colors.neutral.heavy.default, ";");
export var tooltip = _ref2 => {
  var left = _ref2.left,
    top = _ref2.top;
  return /*#__PURE__*/css("position:absolute;left:", left, "px;top:", top, "px;border-radius:3px;padding:2px 4px;box-shadow:", shadow(shadows.elevation3), ";background-color:", colors.neutral.surface.default, ";pointer-events:none;color:", colors.neutral.heavy.default, ";", designTokenFonts.mini, " white-space:nowrap;transform:translateX(-50%) translateY(-50%);");
};
export var dataItem = {
  name: "1i27l4i",
  styles: "display:flex;gap:8px;"
};
export var tooltipValue = /*#__PURE__*/css(designTokenFonts.miniBold);